import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Contract } from '@vonq/hapi-elements-types';
import { TranslocoPipe } from '@jsverse/transloco';
import { collapse } from '../../../../../assets/animations/animations';
import { CatchJobPlatform } from '../../../../enums/catch-job-platforms.enum';
import { FormatPricePipe } from '../../../../pipes/format-price.pipe';
import { JobPlatform } from '../../../../interfaces/job-platform';

@Component({
  selector: 'app-campaign-summary-list',
  templateUrl: './campaign-summary-list.component.html',
  styleUrls: ['./campaign-summary-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [collapse],
  imports: [TranslocoPipe, FormatPricePipe, DecimalPipe],
})
export class CampaignSummaryListComponent {
  platforms = input<JobPlatform[]>([]);
  contracts = input<Contract[]>([]);
  price = input<{ price: number; vat: number; totalPrice: number }>({
    price: 0,
    vat: 0,
    totalPrice: 0,
  });

  /**
   * Returns whether a platform is billed in LinkedIn Sourcing credits.
   * @param {string | number} platformId Platform id
   * @returns {boolean}
   */
  isCreditsPlatform(platformId: string | number): boolean {
    return (
      String(platformId) === CatchJobPlatform.SOURCED_JOBS_LEADS ||
      String(platformId) === CatchJobPlatform.SOURCED_JOBS_AUTOPILOT
    );
  }
}
